// import * as actionTypes from './constants';
// import { updateObject } from '../../shared/utility';

// const initialState = {
//     isInitiated: false,
//     isSuccess: false,
//     isFailed: false,
//     isLoading: false,
//     errorMessage: null,
//     jobList: {},
//     profile: null
// }

// const loginInitiated = (state, action) => {
//     return updateObject(state, {
//         isInitiated: true,
//         isSuccess: false,
//         isFailed: false
//     });
// }
// const loginSuccess = (state, action) => {
//     return updateObject(state, {
//         isInitiated: false,
//         isSuccess: true,
//         jobList: { ...action.data },
//         profile: action.data,
//         isFailed: false
//     });
// }
// const loginFailed = (state, action) => {
//     return updateObject(state, {
//         isInitiated: false,
//         isSuccess: false,
//         isFailed: true,
//         errorMessage: 'Error'
//     });
// }
// const reducer = (state = initialState, action) => {
//     switch (action.type) {
//         case actionTypes.LOGIN_INITIATED: return loginInitiated(state, action);
//         case actionTypes.LOGIN_SUCCESS: return loginSuccess(state, action)
//         case actionTypes.LOGIN_FAILED: return loginFailed(state, action)
//         default:
//             return state;
//     }
// }

// export default reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isInitiated: false,
	isSuccess: false,
	isFailed: false,
	isLoading: false,
	errorMessage: null,
	jobList: {},
	profile: null,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		loginInitiated: (state, action) => {
			state.isInitiated = true;
			state.isSuccess = false;
			state.isFailed = false;
		},
		loginSuccess: (state, action) => {
			state.isInitiated = false;
			state.isSuccess = true;
			state.jobList = { ...action.payload.data };
			state.profile = action.payload.data;
			state.isFailed = false;
		},
		loginFailed: (state, action) => {
			state.isInitiated = false;
			state.isSuccess = false;
			state.isFailed = true;
			state.errorMessage = 'Error';
		},
	},
});

export const { loginInitiated, loginSuccess, loginFailed } = authSlice.actions;
export default authSlice.reducer;
